import { BatteryLevel } from "../../menuPlanningTypes"
import { StandardChip } from "../../../../../../shared/components/badges/StandardChip"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"

export function BatteryStatusChip({ batteryLevel }: { batteryLevel?: BatteryLevel }) {
    const { l10n } = useAppLocalization()

    if (!batteryLevel) {
        return null
    }

    switch (batteryLevel) {
        case BatteryLevel.GOOD:
            return (
                <StandardChip
                    label={l10n.getStringForEnum(
                        "merchant-menu-planning-digital-signage-card-battery-status",
                        batteryLevel.toString(),
                        "Good",
                    )}
                    variant="success"
                />
            )
        case BatteryLevel.POOR_CHILLER:
        case BatteryLevel.POOR:
            return (
                <StandardChip
                    variant="yellow"
                    label={l10n.getStringForEnum(
                        "merchant-menu-planning-digital-signage-card-battery-status",
                        batteryLevel.toString(),
                        "Warning",
                    )}
                />
            )
        case BatteryLevel.UNKNOWN:
            return (
                <StandardChip
                    variant="grey"
                    label={l10n.getStringForEnum(
                        "merchant-menu-planning-digital-signage-card-battery-status",
                        batteryLevel.toString(),
                        "Unknown",
                    )}
                />
            )
        default:
            return (
                <StandardChip
                    variant="red"
                    label={l10n.getStringForEnum(
                        "merchant-menu-planning-digital-signage-card-battery-status",
                        batteryLevel.toString(),
                        "Error",
                    )}
                />
            )
    }
}
